// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MutedBadge__icon-container-fbc402 {
  background-color: var(--addition-110_70);
  border-radius: 24px;
  width: 24px;
  height: 24px;
}

.MutedBadge__icon-container-fbc402 .MutedBadge__icon-f2c745 {
  fill: var(--addition-50);
  padding: var(--indent-4px);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/MutedBadge/MutedBadge.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;EACA,0BAAA;AACF","sourcesContent":[".icon-container {\n  background-color: var(--addition-110_70);\n  border-radius: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.icon-container .icon {\n  fill: var(--addition-50);\n  padding: var(--indent-4px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-container": `MutedBadge__icon-container-fbc402`,
	"iconContainer": `MutedBadge__icon-container-fbc402`,
	"icon": `MutedBadge__icon-f2c745`
};
module.exports = ___CSS_LOADER_EXPORT___;
